<script>
import Tc from '../Tc.vue'
import DataCube from '../helpers/datacube'
import { clone } from './model.mjs'

export default {
    name: 'WorkspaceChartPane',
    inheritAttrs: false,
    props: ['source', 'cache', 'cacheKey', 'pane', 'saved'],
    data: () => ({ cube: null, revision:0 }),
    computed: {
        binding() { return { source:this.source, key:this.cacheKey, cache:this.cache } },
        rows() { return this.source && this.source.data.chart.data },
        chartMetadata() {
            const chart = this.source && this.source.data.chart
            return chart && { type:chart.type, settings:chart.settings, grid:chart.grid, symbolInfo:chart.symbolInfo }
        },
    },
    watch: {
        binding: { immediate:true, handler({source,key}) {
            if (!source) { this.cube = null; return }
            if (!this.cache[key]) {
                const data = clone(source.data)
                data.tool = 'Cursor'
                for (const side of ['onchart','offchart']) data[side] = (data[side] || []).filter(overlay => !overlay.settings?.$state || overlay.settings.$state === 'finished')
                if (this.saved) {
                    data.onchart = clone(this.saved.onchart || [])
                    data.offchart = clone(this.saved.offchart || [])
                    data.drawingPrefs = clone(this.saved.drawingPrefs || {})
                    data.chart.settings = clone(this.saved.chartSettings || data.chart.settings)
                    data.chart.grid = clone(this.saved.chartGrid || data.chart.grid)
                }
                this.$set(this.cache, key, new DataCube(data, { scripts:source.sett.scripts }))
            }
            if (this.cube !== this.cache[key]) this.revision++
            this.cube = this.cache[key]
            this.$set(this.cube.data.chart, 'data', clone(source.data.chart.data))
            this.$nextTick(() => this.$emit('ready'))
        } },
        rows: { deep:true, handler(rows, oldRows) {
            if (!this.cube || !rows) return
            const previous = this.cube.data.chart.data
            const live = rows === oldRows && this.cube.tv && previous.length && rows.length >= previous.length && rows.length <= previous.length + 1 && rows[0][0] === previous[0][0]
            if (live) {
                if (rows.length > previous.length) this.cube.update({candle:rows[rows.length-2].slice()})
                this.cube.update({candle:rows[rows.length-1].slice()})
            } else this.$set(this.cube.data.chart, 'data', clone(rows))
        } },
        chartMetadata: { deep:true, handler(meta) {
            if (!this.cube || !meta) return
            for (const key of Object.keys(meta)) if (meta[key] != null) this.$set(this.cube.data.chart,key,clone(meta[key]))
        } },
    },
    mounted() { this.$emit('ready') },
    methods: {
        setRange(...range) { this.$refs.chart && this.$refs.chart.setRange(...range) },
        getRange() { return this.$refs.chart && this.$refs.chart.getRange() },
    },
    render(h) {
        return this.cube ? h(Tc, {
            key:this.cacheKey + ':' + this.revision, ref:'chart', props:{...this.$attrs,data:this.cube},
            on:this.$listeners,
        }) : h('div')
    },
}
</script>
